// hooks/useBlockBack.ts
import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';

interface UseBlockBackOptions {
  redirectTo?: string;
  onBackAttempt?: () => void;
}

export const useBlockBack = ({
  redirectTo = '/',
  onBackAttempt,
}: UseBlockBackOptions = {}) => {
  const navigate = useNavigate();

  useEffect(() => {
    window.history.pushState(null, '', window.location.href);

    const handlePopState = () => {
      if (onBackAttempt) {
        onBackAttempt();
      } else {
        navigate(redirectTo, {replace: true});
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate, redirectTo, onBackAttempt]);
};
